import React from "react";
import "./adiCard.scss";
import AwardCard from "components/AwardCard/index";
import ADICardImage from "assets/NewBanner/ADICardImage.png";
import { awardCardData } from "components/AwardCard/awardCardData";

/**
 * ADI Card Component
 * @param {Object} props - Component props
 * @param {string} props.title - Card title
 * @returns {JSX.Element} ADI Card component
 */
const ADICard = ({ title = "Awards" }) => {
  return (
    <div className="adiCardContainer">
      <div className="mainCard">
        <div className="adiCardHeader">
          <img src={ADICardImage} alt="Card Logo" className="adiCardLogo" />
          <h2 className="adiCardTitle">
            American Distilling Institute (ADI) International Spirits
            Competition
          </h2>
          <span className="adiCardDescription">
            The American Distilling Institute is the leading authority on
            independent craft distilling. Their competition includes over 1,000
            entries from around the world, judged blindly by a panel of experts.
            Winning at ADI brings national recognition and shines a spotlight on
            emerging brands.
          </span>
        </div>

        <div className="awardsContainer">
          <div className="awardItem">
            <AwardCard {...awardCardData.singleProductOne} />
          </div>

          <div className="awardItem">
            <AwardCard {...awardCardData.singleProductTwo} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ADICard;
